import React, { useState, useEffect } from "react";

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "true");
    localStorage.setItem("cookieConsentDate", new Date().toISOString());
    localStorage.setItem("cookieConsentVersion", "1.0");
    setShowBanner(false);
  };

  const handleDecline = () => {
    localStorage.setItem("cookieConsent", "false");
    sessionStorage.clear();
    localStorage.removeItem("jwtToken");
    localStorage.removeItem("user");
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div
      id="cookie-consent-banner"
      role="dialog"
      aria-label="Cookie Consent"
      aria-describedby="cookie-consent-description"
      data-cookieconsent="banner"
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        width: "100%",
        backgroundColor: "#2c2c2c",
        color: "white",
        padding: "15px",
        textAlign: "center",
        zIndex: 1000,
      }}
    >
      <p id="cookie-consent-description" style={{ marginBottom: "10px" }}>
        Utilizziamo i cookie per migliorare la tua esperienza. Utilizzando il nostro sito, accetti la nostra{" "}
        <a href="/privacy-policy" style={{ color: "#F2C231", textDecoration: "underline" }}>
          Informativa sulla Privacy
        </a>{" "}
        e la nostra{" "}
        <a href="/cookie-policy" style={{ color: "#F2C231", textDecoration: "underline" }}>
          Cookie Policy
        </a>
        . I cookie non essenziali vengono bloccati fino al tuo consenso.
      </p>
      <div>
        <button
          onClick={handleAccept}
          id="cookie-accept-btn"
          data-cookieconsent="accept"
          style={{
            backgroundColor: "#F2C231",
            color: "#000",
            border: "none",
            padding: "8px 16px",
            marginRight: "10px",
            cursor: "pointer",
            borderRadius: "6px",
          }}
        >
          Accetta
        </button>
        <button
          onClick={handleDecline}
          id="cookie-decline-btn"
          data-cookieconsent="deny"
          style={{
            backgroundColor: "transparent",
            color: "#fff",
            border: "1px solid #fff",
            padding: "8px 16px",
            cursor: "pointer",
            borderRadius: "6px",
          }}
        >
          Rifiuta
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
